import React from "react";
import assign from "lodash/assign";
import get from "lodash/get";
import set from "lodash/set";
import randomstring from "just.randomstring";
import { TextField, Checkbox, RaisedButton } from "material-ui";
import { colors } from "material-ui/styles";

import LinkLike from "./partials/link-like.jsx";
import CurrencyField from "./partials/currency-field.jsx";
import InjectedSelect from "./partials/injected-select.jsx";
import SelectField from "./partials/select-field.jsx";
import Label from "./partials/label.jsx";
import InfoNotice from "./partials/info-notice.jsx";
import BackButton from "./partials/back-button.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";
import DateTimeField from "./partials/datetime-field.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import CouponActions from "../actions/CouponActions";
import CouponStore from "../stores/CouponStore";
import EventBucketStore from "../stores/EventBucketStore";
import UserStore from "../stores/UserStore";

class Coupon extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      coupon: null,
      dirty: false,
      showExpiration: false,
      values: {}
    };

    this.onChange = this.onChange.bind(this);
    this.onChangeValue = this.onChangeValue.bind(this);
    this.makeNewRandomCode = this.makeNewRandomCode.bind(this);
    this.makeMultiRandomCodes = this.makeMultiRandomCodes.bind(this);
    this.save = this.save.bind(this);
    this.delete = this.delete.bind(this);
  }

  static getStores() {
    return [CouponStore, EventBucketStore, UserStore];
  }

  static getPropsFromStores() {
    return {
      getCouponById: CouponStore.getCouponById
    };
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {
      checkboxWrapper: {
        margin: "20px 0"
      },
      actions: {
        marginTop: 40
      },
      codeWrapper: {
        position: "relative",
        marginBottom: 30
      },
      controlsWrapper: {
        position: "absolute",
        bottom: -15
      },
      h3: {
        marginTop: 30,
        marginBottom: 10
      }
    };
  }

  onChange(id, e, checked) {
    this.onChangeValue(
      id,
      typeof checked !== "undefined"
        ? !get(this.state.values, id)
        : e.target.value
    );
  }

  onChangeValue(id, value) {
    this.state.dirty = true;
    set(this.state.values, id, value);
    this.setState(this.state);
  }

  _makeCode() {
    return randomstring(15, "numbers_uppercases");
  }

  makeNewRandomCode() {
    this.state.dirty = true;
    this.state.values.code = this._makeCode();
    this.setState(this.state);
  }

  makeMultiRandomCodes() {
    let count = window.prompt("How many codes would you like to generate?"),
      newValues = Array.apply(null, Array(+count)).map(this._makeCode);

    this.state.dirty = true;
    this.state.values.codes = this.state.values.codes
      .filter(c => !!c)
      .concat(newValues);
    this.setState(this.state);
  }

  save() {
    var values = assign({}, this.state.values);
    values.codes = values.codes.filter(c => !!c); // strip empty codes
    CouponActions.edit(this.props.params.couponId, values);
  }

  delete() {
    let bucket = this.state.coupon.event_bucket;
    if (window.confirm("Are you sure?")) {
      CouponActions.delete(this.props.params.couponId);
      this.context.router.push(`/event_buckets/${bucket}/coupons`);
    }
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(newProps) {
    var coupon = newProps.getCouponById(newProps.params.couponId);

    if (!this.state.isFetchingCoupon && !coupon) {
      CouponActions.fetchOne(newProps.params.couponId);
      this.setState({ isFetchingCoupon: true });
    } else if (coupon) {
      this.setState({ isFetchingCoupon: false });
    }

    this.setState({
      coupon,
      dirty: false,
      showExpiration: coupon ? (coupon.expiration ? true : false) : false,
      values: coupon
        ? {
            name: coupon.name || "",
            multicode: coupon.multicode || false,
            code: coupon.code || "",
            codes: coupon.codes || [],
            active: coupon.active || false,
            expiration: coupon.expiration || null,
            target: {
              all: get(coupon, "target.all", false),
              all_tickets: get(coupon, "target.all_tickets", false),
              all_passes: get(coupon, "target.all_passes", false),
              all_items: get(coupon, "target.all_items", false),
              ids: get(coupon, "target.ids", []),
              exclude_ids: get(coupon, "target.exclude_ids", [])
            },
            result: {
              price: {
                percent_off: get(coupon, "result.price.percent_off", null),
                cents_off: get(coupon, "result.price.cents_off", null),
                set_price: get(coupon, "result.price.set_price", null),
                cents_off_item: get(coupon, "result.price.cents_off_item", null)
              },
              ticket_message: get(coupon, "result.ticket_message", null)
            },
            restrictions: {
              uses: {
                total: get(coupon, "restrictions.uses.total", null),
                per_person: get(coupon, "restrictions.uses.per_person", null),
                total_items: get(coupon, "restrictions.uses.total_items", null),
                per_code: get(coupon, "restrictions.uses.per_code", null),
                per_person_per_event: get(
                  coupon,
                  "restrictions.uses.per_person_per_event",
                  null
                )
              },
              recurrence_duration: get(
                coupon,
                "restrictions.recurrence_duration",
                null
              )
            }
          }
        : {}
    });
  }

  render() {
    var styles = this.getStyles();

    if (!this.state.coupon) {
      return <WorkingIndicator fullPage={true} />;
    }

    const eventBucket =
      EventBucketStore.getEventBucketById(this.props.params.eventBucketId) ||
      {};

    let saveButton = (
      <RaisedButton
        label={this.state.dirty ? "Save changes" : "No changes to save"}
        primary={true}
        disabled={!this.state.dirty}
        onClick={this.save}
      />
    );

    return (
      <div>
        <div>
          <BackButton
            label={
              this.props.location.state && this.props.location.state.fromListing
                ? "discounts"
                : "discount"
            }
            style={{ marginRight: 7 }}
            onTouchTap={() =>
              this.props.location.state && this.props.location.state.fromListing
                ? this.context.router.goBack()
                : this.context.router.push(
                    `/event_buckets/${this.props.params.eventBucketId}/coupons/${this.props.params.couponId}`
                  )
            }
          />
          {UserStore.hasPermission("edit_coupon") ? saveButton : null}
        </div>
        {UserStore.hasPermission("edit_coupon") ? (
          <InfoNotice style={{ marginTop: 20 }}>
            Check out our{" "}
            <a
              href="http://help.eventive.org/discounts/create-discounts"
              target="_blank"
            >
              guide to creating discounts
            </a>
            .
          </InfoNotice>
        ) : null}
        <div>
          <div>
            <TextField
              value={get(this.state, "values.name", "") || ""}
              floatingLabelText="Name"
              floatingLabelFixed={true}
              onChange={e => this.onChangeValue("name", e.target.value)}
              disabled={!UserStore.hasPermission("edit_coupon")}
            />
          </div>
          {this.state.values.multicode ? (
            <div style={styles.codeWrapper}>
              <TextField
                value={get(this.state, "values.codes", []).join("\n") || ""}
                multiLine={true}
                rows={2}
                rowsMax={10}
                floatingLabelText={`Codes (count: ${this.state.values.codes.length})`}
                floatingLabelFixed={true}
                onChange={e =>
                  this.onChangeValue("codes", e.target.value.split(/[\r\n]+/g))
                }
                disabled={!UserStore.hasPermission("edit_coupon")}
              />
              {UserStore.hasPermission("edit_coupon") ? (
                <div style={styles.controlsWrapper}>
                  <LinkLike onTouchTap={this.makeMultiRandomCodes}>
                    Generate random codes
                  </LinkLike>
                  &nbsp;
                  <LinkLike
                    onTouchTap={() => this.onChangeValue("multicode", false)}
                  >
                    Switch to single code
                  </LinkLike>
                </div>
              ) : null}
            </div>
          ) : (
            <div style={styles.codeWrapper}>
              <TextField
                value={get(this.state, "values.code", "") || ""}
                floatingLabelText="Code"
                floatingLabelFixed={true}
                onChange={e => this.onChangeValue("code", e.target.value)}
                disabled={!UserStore.hasPermission("edit_coupon")}
              />
              {UserStore.hasPermission("edit_coupon") ? (
                <div style={styles.controlsWrapper}>
                  <LinkLike onTouchTap={this.makeNewRandomCode}>
                    Generate a new random code
                  </LinkLike>
                  &nbsp;
                  <LinkLike
                    style={styles.a}
                    onTouchTap={() => this.onChangeValue("multicode", true)}
                  >
                    Switch to multicode
                  </LinkLike>
                </div>
              ) : null}
            </div>
          )}
          <div style={styles.checkboxWrapper}>
            <Label>Status</Label>
            <Checkbox
              label="Active (allow customers to use)"
              checked={this.state.values.active}
              onCheck={this.onChange.bind(null, "active")}
              disabled={!UserStore.hasPermission("edit_coupon")}
            />
          </div>
          <div style={styles.checkboxWrapper}>
            <Label>Limit availability</Label>
            <Checkbox
              label="Include an expiration date for this discount"
              checked={this.state.showExpiration ? true : false}
              onClick={e => {
                this.setState(
                  { showExpiration: !this.state.showExpiration },
                  function () {
                    if (!this.state.showExpiration) {
                      this.onChangeValue("expiration", null);
                    }
                  }
                );
              }}
              disabled={!UserStore.hasPermission("edit_coupon")}
            />
            {this.state.showExpiration ? (
              <DateTimeField
                value={get(this.state, "values.expiration", "") || ""}
                label="Expiration date"
                useMoment={true}
                unclearable={true}
                timezone={eventBucket.timezone}
                onChange={(e, v) => {
                  this.onChangeValue("expiration", v);
                }}
                style={{ display: "inline-block", marginRight: 24 }}
              />
            ) : null}
          </div>
          <div>
            <h3 style={styles.h3}>Target</h3>
            <p>Rules to select the orders that can use this discount code.</p>
            <div>
              <Checkbox
                label="Apply to all orders"
                checked={this.state.values.target.all}
                onCheck={this.onChange.bind(null, "target.all")}
                disabled={!UserStore.hasPermission("edit_coupon")}
              />
            </div>
            <div>
              <Checkbox
                label="Apply to all ticket orders"
                checked={this.state.values.target.all_tickets}
                onCheck={this.onChange.bind(null, "target.all_tickets")}
                disabled={!UserStore.hasPermission("edit_coupon")}
              />
            </div>
            <div>
              <Checkbox
                label="Apply to all pass orders"
                checked={this.state.values.target.all_passes}
                onCheck={this.onChange.bind(null, "target.all_passes")}
                disabled={!UserStore.hasPermission("edit_coupon")}
              />
            </div>
            <div>
              <Checkbox
                label="Apply to all item orders"
                checked={this.state.values.target.all_items}
                onCheck={this.onChange.bind(null, "target.all_items")}
                disabled={!UserStore.hasPermission("edit_coupon")}
              />
            </div>
            {!this.state.values.target.all && (
              <div>
                <InjectedSelect
                  value={get(this.state.values, "target.ids", [])}
                  types={[
                    "ticket_buckets",
                    "pass_buckets",
                    "item_buckets",
                    "tags"
                  ]}
                  multi={true}
                  label={(() => {
                    let additionalItems = [
                      this.state.values.target.all_tickets && "tickets",
                      this.state.values.target.all_passes && "passes",
                      this.state.values.target.all_items && "items"
                    ].filter(x => !!x);
                    return `Items to apply to ${
                      additionalItems.length
                        ? `(in addition to all ${additionalItems.join(" & ")})`
                        : ""
                    }`;
                  })()}
                  labelFormatter={{
                    pass_buckets: b => `${b.name}`,
                    ticket_buckets: b => `${b.event.name} – ${b.name}`,
                    item_buckets: b => `${b.name}`,
                    tags: b => `${b.name}`
                  }}
                  eventBucketId={this.props.params.eventBucketId}
                  onChange={selected =>
                    this.onChangeValue("target.ids", selected)
                  }
                  disabled={!UserStore.hasPermission("edit_coupon")}
                />
              </div>
            )}
            <div>
              <InjectedSelect
                value={get(this.state.values, "target.exclude_ids", [])}
                types={[
                  "ticket_buckets",
                  "pass_buckets",
                  "item_buckets",
                  "tags"
                ]}
                multi={true}
                label="Items to exclude"
                labelFormatter={{
                  pass_buckets: b => `${b.name}`,
                  ticket_buckets: b => `${b.event.name} – ${b.name}`,
                  item_buckets: b => `${b.name}`,
                  tags: b => `${b.name}`
                }}
                eventBucketId={this.props.params.eventBucketId}
                onChange={selected =>
                  this.onChangeValue("target.exclude_ids", selected)
                }
                disabled={!UserStore.hasPermission("edit_coupon")}
              />
            </div>
          </div>
          <div>
            <h3 style={styles.h3}>Result</h3>
            <p>Rules to determine the effects of this discount code.</p>
            <div>
              <TextField
                value={
                  get(this.state, "values.result.price.percent_off", "") || ""
                }
                floatingLabelText="% off order (0-100)"
                floatingLabelFixed={true}
                placeholder="0"
                onChange={e =>
                  this.onChangeValue("result.price.percent_off", e.target.value)
                }
                disabled={!UserStore.hasPermission("edit_coupon")}
              />
            </div>
            <div>
              <CurrencyField
                value={
                  get(this.state, "values.result.price.cents_off", "") || ""
                }
                floatingLabelText="Dollars off order"
                floatingLabelFixed={true}
                placeholder="$0.00"
                onChange={e =>
                  this.onChangeValue("result.price.cents_off", e.target.value)
                }
                disabled={!UserStore.hasPermission("edit_coupon")}
              />
            </div>
            <div>
              <CurrencyField
                value={
                  get(this.state, "values.result.price.set_price", "") || ""
                }
                floatingLabelText="Set price per item"
                floatingLabelFixed={true}
                placeholder="None"
                onChange={e =>
                  this.onChangeValue("result.price.set_price", e.target.value)
                }
                disabled={!UserStore.hasPermission("edit_coupon")}
              />
            </div>
            <div>
              <CurrencyField
                value={
                  get(this.state, "values.result.price.cents_off_item", "") ||
                  ""
                }
                floatingLabelText="Dollars off per item"
                floatingLabelFixed={true}
                placeholder="$0.00"
                onChange={e =>
                  this.onChangeValue(
                    "result.price.cents_off_item",
                    e.target.value
                  )
                }
                disabled={!UserStore.hasPermission("edit_coupon")}
              />
            </div>
          </div>
          <div>
            <h3 style={styles.h3}>Restrictions</h3>
            <p>Restrictions that govern the use of this discount code.</p>
            <div>
              <TextField
                value={
                  get(this.state, "values.restrictions.uses.total", "") || ""
                }
                floatingLabelText="Total number of orders (globally)"
                floatingLabelFixed={true}
                placeholder="Unlimited"
                onChange={e =>
                  this.onChangeValue("restrictions.uses.total", e.target.value)
                }
                disabled={!UserStore.hasPermission("edit_coupon")}
              />
            </div>
            <div>
              <TextField
                value={
                  get(this.state, "values.restrictions.uses.total_items", "") ||
                  ""
                }
                floatingLabelText="Total number of items (globally)"
                floatingLabelFixed={true}
                placeholder="Unlimited"
                onChange={e =>
                  this.onChangeValue(
                    "restrictions.uses.total_items",
                    e.target.value
                  )
                }
                disabled={!UserStore.hasPermission("edit_coupon")}
              />
            </div>
            <div>
              <TextField
                value={
                  get(this.state, "values.restrictions.uses.per_person", "") ||
                  ""
                }
                floatingLabelText="Total number of items per person"
                floatingLabelFixed={true}
                placeholder="Unlimited"
                onChange={e =>
                  this.onChangeValue(
                    "restrictions.uses.per_person",
                    e.target.value
                  )
                }
                disabled={!UserStore.hasPermission("edit_coupon")}
              />
            </div>
            <div>
              <TextField
                value={
                  get(
                    this.state,
                    "values.restrictions.uses.per_person_per_event",
                    ""
                  ) || ""
                }
                floatingLabelText="Total number of tickets per event per person"
                floatingLabelFixed={true}
                floatingLabelStyle={{ whiteSpace: "nowrap" }}
                placeholder="Unlimited"
                onChange={e =>
                  this.onChangeValue(
                    "restrictions.uses.per_person_per_event",
                    e.target.value
                  )
                }
                disabled={!UserStore.hasPermission("edit_coupon")}
              />
            </div>
            <div>
              <SelectField
                value={
                  get(
                    this.state,
                    "values.restrictions.recurrence_duration",
                    ""
                  ) || "once"
                }
                label="For recurring orders, duration to apply discount"
                style={{ maxWidth: 300 }}
                options={[
                  { label: "Once (only apply to first order)", value: "once" },
                  {
                    label: "Forever (apply to first order & renewals)",
                    value: "forever"
                  }
                ]}
                onChange={selected =>
                  this.onChangeValue(
                    "restrictions.recurrence_duration",
                    selected.value
                  )
                }
                disabled={!UserStore.hasPermission("edit_coupon")}
              />
            </div>
          </div>
          {this.state.values.multicode ? (
            <div>
              <h3 style={styles.h3}>Per-code restrictions</h3>
              <p>
                Since this discount has multiple codes, you can also restrict
                uses by code.
              </p>
              <div>
                <TextField
                  value={
                    get(this.state, "values.restrictions.uses.per_code", "") ||
                    ""
                  }
                  floatingLabelText="Total number of items per code"
                  floatingLabelFixed={true}
                  placeholder="Unlimited"
                  onChange={e =>
                    this.onChangeValue(
                      "restrictions.uses.per_code",
                      e.target.value
                    )
                  }
                />
              </div>
            </div>
          ) : null}
          <div>
            <h3 style={styles.h3}>Advanced options</h3>
            <Checkbox
              label="Show a custom message on tickets purchased with discount"
              checked={
                this.state.showTicketMessageEditor ||
                this.state.values.result.ticket_message
              }
              onCheck={(e, checked) =>
                this.setState({ showTicketMessageEditor: checked }, () =>
                  this.onChangeValue("result.ticket_message", null)
                )
              }
              disabled={!UserStore.hasPermission("edit_coupon")}
            />
            {this.state.showTicketMessageEditor ||
            this.state.values.result.ticket_message ? (
              <TextField
                value={get(this.state, "values.result.ticket_message", "")}
                placeholder="Custom message"
                style={{ marginLeft: "2.5em" }}
                onChange={e => {
                  let v = e.target.value;
                  this.setState({ showTicketMessageEditor: true }, () =>
                    this.onChangeValue("result.ticket_message", v)
                  );
                }}
              />
            ) : null}
          </div>
        </div>
        {UserStore.hasPermission("edit_coupon") ? (
          <div style={styles.actions}>
            {saveButton}
            <RaisedButton
              label="Delete discount"
              onClick={this.delete}
              style={{ marginLeft: 7 }}
            />
          </div>
        ) : null}
      </div>
    );
  }
}

export default connectToStores(Coupon);



// WEBPACK FOOTER //
// ./src/app/components/coupon-editor.jsx